import { useTranslation } from 'react-i18next';

export default function CoverageSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <img
              src="https://storage.readdy-site.link/project_files/178025fa-ed44-4d24-9298-29f9cea8fee2/2408b6e6-cc9c-4038-9e76-3b3be35ed77b_D8CFFE65-7E89-48DA-954D-89BA705866EB.png?v=17b6103bc65ecbe51cbb405edab4596e"
              alt="Cobertura USA"
              className="w-full h-auto rounded-2xl"
            />
          </div>

          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {t('coverage.title')}
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              {t('coverage.p1')}
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              {t('coverage.p2')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}